import { render } from 'preact';
import { App } from './App';
import './styles/tokens.css';
import './styles/global.css';

const root = document.getElementById('app');
if (!root) throw new Error('No #app element');
render(<App />, root);
